import config from '../config';

// ✅ Get all farms
export const getAllFarms = async () => {
  const response = await fetch(`${config.apiUrl}/api/farms`);
  if (!response.ok) throw new Error('Failed to fetch farms');
  return response.json();
};
export const getMyFarms = async (clientId) => {
  const response = await fetch(`${config.apiUrl}/api/farms/myfarms/get?client_id=${clientId}`);
  const data = await response.json(); // <-- Always parse JSON first
  
  if (!response.ok) {
    throw new Error(data.message || 'Failed to fetch farms');
  }

  return data;
};
// ✅ Get farm by ID
export const getFarmById = async (id) => {
  const response = await fetch(`${config.apiUrl}/api/farms/${id}`);
  if (!response.ok) throw new Error('Farm not found');
  return response.json();
};

// ✅ Create a new farm
export const createFarm = async (farmData) => {
  const response = await fetch(`${config.apiUrl}/api/farms`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(farmData),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// ✅ Update an existing farm
export const updateFarm = async (id, farmData) => {
  const response = await fetch(`${config.apiUrl}/api/farms/${id}`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(farmData),
  });
  if (!response.ok) {
    const errorResponse = await response.json();
    throw new Error(JSON.stringify(errorResponse));
  }
  return response.json();
};

// ✅ Delete a farm (soft delete)
export const deleteFarm = async (id) => {
  const response = await fetch(`${config.apiUrl}/api/farms/${id}`, {
    method: 'DELETE',
  });
  if (!response.ok) throw new Error('Failed to delete farm');
  return response.json();
};
